import React from 'react'
import { Skeleton } from 'antd'
import { SkeletonInputProps } from 'antd/es/skeleton/Input'

export type SkeletonBlockProps = SkeletonInputProps & { width?: number }

const SkeletonBlock = ({ width, ...skeletonProps }: SkeletonBlockProps) => (
    <Skeleton.Input
        {...skeletonProps}
        active={true}
        size="small"
        style={{
            ...skeletonProps.style,
            width: width ?? '100%',
            height: 22,
        }}
    />
)

export default SkeletonBlock
